import { createSelector } from '@ngrx/store';
import { IExpensesState } from './expenses.reducer';
const expensesStore = (state: any) => state.expenses as IExpensesState;
export const selectExpensesLista = createSelector(
  expensesStore,
  (state) => state.lista
);
